import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmationPageProps {
  isSignOut?: boolean;
  completedText?: string;
}

const ConfirmationPage: React.FC<ConfirmationPageProps> = ({
  isSignOut = false,
  completedText,
}) => {
  const { t } = useTranslation();

  const defaultCompletedText = t("selfSignIn.confirmation.defaultMessage");
  const title = isSignOut
    ? t("selfSignIn.confirmation.signOutSuccessful")
    : t("selfSignIn.confirmation.signInSuccessful");

  return (
    <div className="workflow-container centered">
      <div className="confirmation-message">
        <h2>{title}</h2>
        <p>{completedText || defaultCompletedText}</p>
      </div>
    </div>
  );
};

export default ConfirmationPage;
